<template>
  <div>
    <main-layout>
      <MainMenu />
      <v-container>
        <h1>{{ $t('customer_list') }}</h1>
        <div class="pb-3">
          <v-breadcrumbs :items="breadcrumbItems">
            <template #item="props">
              <router-link
                :to="{ name: 'customer' }"
                :class="[props.item.disabled && 'disabled']"
                >{{ props.item.text.toUpperCase() }}</router-link
              >
            </template>
          </v-breadcrumbs>
        </div>
        <div>
          <div class="pa-3 mb-5" style="background: #fbfbfb; border-radius: 8px">
            <div class="primary--text mb-4">แก้ไขข้อมูลลูกค้า</div>
            <CustomerManage
              v-if="customerInfo"
              v-model="customerInfo"
              @onSave="handleSaveCustomerInfo"
            ></CustomerManage>
          </div>
          <div class="pa-3" style="background: #fbfbfb; border-radius: 8px">
            <div class="primary--text mb-3">ประวัติการแก้ไข</div>
            <ChangeLog />
          </div>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import MainMenu from './MainMenu.vue'
import CustomerManage from './CustomerManage.vue'
import { mapGetters } from 'vuex'
import tremendousApi from '@/api/tremendous'
import { handleResponse, handleApiError } from '@/api/util'
import ChangeLog from './ChangeLog.vue'

export default {
  components: {
    MainMenu,
    CustomerManage,
    ChangeLog
  },
  data() {
    return {
      tabs: 'customer-info',
      breadcrumbItems: [
        {
          text: this.$t('customer_list'),
          disabled: false,
          href: 'customer'
        },
        {
          text: this.$t('customer_info'),
          disabled: true,
          href: 'customer'
        }
      ],
      customerInfo: null,
      originalCustomerInfo: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    customerId() {
      return this.$route && this.$route.params.id
    }
  },
  watch: {
    customerInfo(value) {
      this.originalCustomerInfo = { ...value }
    }
  },
  async mounted() {
    await this.handleGetCustomerById()

    if (this.$store.state.tremendousMasterData.branch.length === 0) {
      this.handleGetMasterDataBranch()
    }
  },

  methods: {
    async handleGetCustomerById() {
      const vm = this
      try {
        const data = {
          id: vm.customerId,
          limit: 1,
          offset: 0
        }

        vm.$store.dispatch('loading')
        const response = await tremendousApi.getCustomerList({
          pageId: vm.selectedBot.pageid,
          config: {
            params: data
          }
        })
        await handleResponse(response)
        vm.$store.dispatch('loading')

        if (response && response.status === 200) {
          vm.customerInfo = response.data.data[0]
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        handleApiError(error)
      }
    },
    async handleSaveCustomerInfo(payload) {
      const createDiffData = () => {
        const fields = [
          'full_name',
          'customer_type',
          'email',
          'phone_number',
          'branch_id',
          'pledge_water_tank',
          'total_pledge_water_tank',
          'file_url',
          'address_lat',
          'address_long'
        ]

        return fields
          .map((field) => ({
            field_name: field,
            before:
              this.originalCustomerInfo[field] === '[]' ? '' : this.originalCustomerInfo[field],
            after: this.customerInfo[field] === '[]' ? '' : this.customerInfo[field]
          }))
          .filter(({ before, after }) => `${before}` !== `${after}`)
      }

      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await tremendousApi.patchUpdateMember({
          pageId: vm.selectedBot.pageid,
          memberId: vm.customerId,
          data: {
            ...payload,
            action: 'edit',
            edit_field_list: {
              data: createDiffData()
            }
          }
        })
        await handleResponse(response)
        vm.$store.dispatch('loading')

        if (response && response.status === 200) {
          await vm.$swal.fire({
            text: 'บันทึกสำเร็จ',
            type: 'success'
          })
          vm.$router.push({ name: 'customer' })
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    async handleGetMasterDataBranch() {
      try {
        const response = await tremendousApi.getBranchList()
        await handleResponse(response)

        if (response && response.status === 200) {
          this.$store.state.tremendousMasterData.branch = response.data.data
        }
      } catch (error) {
        handleApiError(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
tr > td {
  white-space: nowrap;
}
.disabled {
  color: grey;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/Tremendous/CustomerInfo.vue